import * as _ from "lodash";
import { isEqual } from "lodash";
import * as React from "react";

import { CustomerType } from "../types/index";
import ToggleButtonGroup from "./ToggleButtonGroup";

interface Props {
  onChange: (customerType: CustomerType[]) => void;
  customerType: CustomerType[];
}

class CustomerTypeFilter extends React.Component<Props> {
  private privateCustomersSelected = (): boolean =>
    isEqual(this.props.customerType, [CustomerType.PK]);
  private companyCustomersSelected = (): boolean =>
    isEqual(this.props.customerType, [CustomerType.GK]);
  private allCustomersSelected = (): boolean =>
    _.includes(this.props.customerType, CustomerType.PK) &&
    _.includes(this.props.customerType, CustomerType.GK);

  private buttons = [
    {
      label: "Alle",
      selected: () => this.allCustomersSelected(),
      onClick: () => this.props.onChange([CustomerType.PK, CustomerType.GK]),
    },
    {
      label: "Privatkunden",
      selected: () => this.privateCustomersSelected(),
      onClick: () => this.props.onChange([CustomerType.PK]),
    },
    {
      label: "Gewerbekunden",
      selected: () => this.companyCustomersSelected(),
      onClick: () => this.props.onChange([CustomerType.GK]),
    },
  ];

  public render() {
    return <ToggleButtonGroup title="Kundentyp" buttons={this.buttons} />;
  }
}

export default CustomerTypeFilter;



// WEBPACK FOOTER //
// ./src/components/CustomerTypeFilter.tsx